export default __webpack_public_path__ + "static/media/Elizabeth-Smedley-Grid.de0d7485.jpg";